<div class="top-banner-container sticky-header">
  <div class="top-banner-hamburger-menu-link" *ngIf="!isMobileScreen">
    <a (click)="isSideBarOpenFunction()">
      <img
        src="assets/images/hambuger.png"
        srcset="
          assets/images/hambuger@2x.png 2x,
          assets/images/hambuger@3x.png 3x
        "
        class="hambuger cursor-pointer"
      />
    </a>
  </div>
  <div class="top-banner-center-panel">&nbsp;</div>
  <div class="top-banner-rightside-panel">
    <div class="search-icon-link align-items-center">
      <div class="dropdown d-flex align-items-center me-3 notifications-wrapper" (shown.bs.dropdown)="markAllRead()">
        <a class="nav-link dropdown-toggle position-relative"
           href="#"
           role="button"
           data-bs-toggle="dropdown"
           aria-expanded="false">
          <i class="far fs-4 fa-bell"></i>

          <!-- Badge -->
          <span class="notification-badge badge rounded-pill bg-danger"
                *ngIf="(unreadCount$ | async) as count"
                [hidden]="count === 0">
            {{ count > 20 ? '20+' : count }}
          </span>

        </a>

        <!-- Dropdown -->
        <ul class="dropdown-menu dropdown-menu-end notifications-dropdown shadow">

       

          <li *ngFor="let n of unreadNotifications$ | async">
            <div class="dropdown-item small d-flex align-items-start justify-content-between"
                 (click)="openNotification(n)"
                 [ngClass]="{ 'notification-read': n.read, 'notification-unread': !n.read }">

              <div class="me-2">
                <div class="fw-bold">{{ n.notificationAlert.title }}</div>
                <div class="text-muted">{{ n.notificationAlert.description }}</div>
                <small class="text-secondary ps-0" style="font-size:0.7rem">
                  {{ n.occurredAt | date:'dd MMM yyyy, hh:mm a' }}
                </small>
              </div>

              <a href="javascript:void(0)"
                 class="text-muted ms-2"
                 title="Dismiss"
                 (click)="dismiss(n, $event)">
                <i class="fa fa-times"></i>
              </a>

            </div>
          </li>



          <li *ngIf="(unreadNotifications$ | async)?.length === 0">
            <span class="dropdown-item text-muted text-center">No new notifications</span>
          </li>

        </ul>
      </div>
    </div>
   



    <div class="profile-icon custom-dropdown-menu">
      <div class="position-relative" [container]="'body'" ngbDropdown #userProfileMenuDropdown="ngbDropdown" [autoClose]="autoClose">
        <div class="profile-icon-circle cursor-pointer dropdown-toggl" id="user-profile-menu-dropdown" ngbDropdownToggle>
          <img [src]="imageUrl" class="person_FILL1_wght700_GRAD0_opsz48" />
        </div>
        <div class="dropdown-menu p-0 profile-panel" ngbDropdownMenu aria-labelledby="user-profile-menu-dropdown">
          <div class="profile-panel-wrapper">
            <div class="profile-info" (click)="openUserProfilePage()">
              <div class="profile-icon-circle">
                <img [src]="imageUrl"
                     class="person_FILL1_wght700_GRAD0_opsz48" />
              </div>
              <div class="profile-name-and-email">
                <div class="name text-truncate">
                  {{ user ? user.firstName + " " + user.lastName : "" }}
                </div>
                <div class="email text-truncate">{{ user ? user.emailAddress : "" }}</div>
              </div>
            </div>
            <div class="hr1">
              <hr />
            </div>
            <div class="view-profile-link custom-bg-hover-effect" *ngIf="IsSalesCompany || IsVet" (click)="openUserProfilePage();" ngbDropdownItem>
              <span class="cursor-pointer">User&nbsp;Profile</span>
            </div>
            <!--<div class="view-profile-link custom-bg-hover-effect" *ngIf="IsVet" (click)="openMemberProfilePage();" ngbDropdownItem>
            <span class="cursor-pointer">Vet&nbsp;Clinic&nbsp;Profile</span>
          </div>-->
            <!--<div class="view-profile-link custom-bg-hover-effect" *ngIf="IsSalesCompany" (click)="openMemberProfilePage();" ngbDropdownItem>
            <span class="cursor-pointer">Sales&nbsp;Admin&nbsp;Profile</span>
          </div>-->
            <div class="settings-link custom-bg-hover-effect" *ngIf="IsAdmin && IsSalesCompany" (click)="RedirectUserManagement();" ngbDropdownItem>
              <span class="cursor-pointer">User&nbsp;Managment</span>
            </div>
            <!--<div class="settings-link custom-bg-hover-effect" *ngIf="IsSalesCompany" (click)="redirectToContacts();" ngbDropdownItem>
            <span class="cursor-pointer">Contacts</span>
          </div>-->
            <!--<div class="settings-link custom-bg-hover-effect" (click)="openSaleAdminPopup();" *ngIf="IsSalesCompany" ngbDropdownItem>
            <span>Admin Notification Settings</span>
          </div>-->
            <!--<div class="settings-link-2 custom-bg-hover-effect" (click)="redirectToVetNotificationSettings();" *ngIf="IsVet" ngbDropdownItem>
            <span>Vet Notification Settings</span>
          </div>-->
            <div class="change-password-link custom-bg-hover-effect" (click)="openChangePasswordPopup();" ngbDropdownItem>
              <span>Change Password</span>
            </div>
            <div class="hr2">
              <hr />
            </div>
            <div class="sign-out-link custom-bg-hover-effect" (click)="logout()" ngbDropdownItem>
              <span>Sign&nbsp;Out</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
